/* eslint func-style: "off" */

import { all, call, fork, takeLatest } from 'redux-saga/effects';

import apiClient from 'helpers/apiClient';
import { SAVE_ACCOUNT } from './DataSources.ducks';

const saveAccount = function* (action) {
  try {
    const account = action.payload.account;
    action.payload.displayOptions.forEach(({displayValue}) => {
      account.attributes[displayValue] = {
        ...account.attributes[displayValue],
        ...action.payload[displayValue]
      };
    });

    yield call(apiClient, `/api/accounts/${account.id}`, {
      method: 'PUT',
      body: JSON.stringify(account)
    });
    Account.toastrNotifications._successMessage({
      success_title: '',
      success_message: 'Your account settings have been updated successfully!'
    });
    Vent.trigger('change:datasources_settings', {});
  } catch(e) {
    Account.toastrNotifications._errorMessage({
      error_title: '',
      error_message: 'There was a problem updating your account settings.'
    });
  }
};

const saveAccountSaga = function* () {
  yield takeLatest(SAVE_ACCOUNT, saveAccount);
};

const sagas = function* () {
  yield all([
    fork(saveAccountSaga),
  ]);
};

export {
  saveAccount,
  saveAccountSaga
};

export default sagas;
